import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { AppComponent } from './student-desktop.component';
import { ShowCardsComponent } from './show-cards/show-cards.component';
import { NewCardComponent } from './new-card/new-card.component';
import { ShowMovimientosComponent } from './show-movimientos/show-movimientos.component';

@NgModule({
	declarations: [
		AppComponent,
    	ShowCardsComponent,
    	NewCardComponent,
    	ShowMovimientosComponent
	],
  	imports: [
   		BrowserModule,
    	HttpModule
  	],
 	providers: [
  	],
  	bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/student-desktop.module.ts